import lodashGet from 'lodash/get';
import moment from 'moment';
import { AUTH_CONFIG, AUTH_TYPE_CONFIG, AuthorityFeature, } from '@/api/logical/productAuth';
import { apis } from '../../../config';
import { api } from '../../../api/api';
import { wait } from '@/api/util';
const inEdm = process.env.BUILD_ISEDM;
const PRODUCT_ID = 'PRODUCT_ID';
const privilegeFallbackData = {
    data: {
        productId: 'sirius',
        productVersionId: 'sirius',
        productVersionName: '尊享版',
        privileges: [
            {
                resourceLabel: 'PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE',
                resourceName: '写信页入口',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'PRAISE_EMAIL_MEDAL',
                resourceName: '勋章',
                accessList: [
                    {
                        accessLabel: 'OP',
                        accessName: '操作',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                    {
                        accessLabel: 'VIEW',
                        accessName: '查看',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                    {
                        accessLabel: 'CANCEL',
                        accessName: '取消',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                    {
                        accessLabel: 'DECORATE',
                        accessName: '设为挂饰',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'READ_EMIAIL',
                resourceName: '读信',
                accessList: [
                    {
                        accessLabel: 'TRANSLATIONS',
                        accessName: '翻译',
                        accessValueType: 'JSON',
                        accessValue: '[{"from":"en","to":"zh","label":"英译中"},{"from":"en","to":"ko-kr","label":"英译韩"},{"from":"en","to":"ja-jp","label":"英译日"},{"from":"zh","to":"en","label":"中译英"},{"from":"zh","to":"ko-kr","label":"中译韩"},{"from":"zh","to":"ja-jp","label":"中译日"},{"from":"ko-kr","to":"en","label":"韩译英"},{"from":"ko-kr","to":"zh","label":"韩译中"},{"from":"ko-kr","to":"ja-jp","label":"韩译日"},{"from":"ja-jp","to":"en","label":"日译英"},{"from":"ja-jp","to":"zh","label":"日译中"},{"from":"ja-jp","to":"ko-kr","label":"日译韩"}]',
                    },
                ],
            },
            {
                resourceLabel: 'VIP_CS_ENTRANCE',
                resourceName: 'VIP专属客服入口',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'VIP_CS_SEND_MESSAGE',
                resourceName: 'VIP专属客服发送自定义消息',
                accessList: [
                    {
                        accessLabel: 'SEND',
                        accessName: '发送',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'STRANGER_NOTIFY_SETTING_PAGE',
                resourceName: '陌生人提醒设置页面',
                accessList: [
                    {
                        accessLabel: 'VIEW',
                        accessName: '查看',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'MAIL_TRACE_SHOW_READ_STATUS',
                resourceName: '发件箱邮件详情展示阅读状态',
                accessList: [
                    {
                        accessLabel: 'INNER_DOMAIN',
                        accessName: '域内',
                        accessValueType: 'BOOL',
                        accessValue: true,
                    },
                    {
                        accessLabel: 'OUT_DOMAIN',
                        accessName: '域外',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'MAIL_TRACE_WRITE_EMAIL',
                resourceName: '邮件追踪写信页设置',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'ADMIN_SITE_ENTRANCE',
                resourceName: '管理后台入口',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'IM',
                resourceName: 'IM消息',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'MAIL_SHARE_WECHAT',
                resourceName: '邮件分享到微信',
                accessList: [
                    {
                        accessLabel: 'SWITCH',
                        accessName: '开关',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'EDISK_CAPACITY',
                resourceName: '云文档容量',
                accessList: [
                    {
                        accessLabel: 'NOTICE_TYPE',
                        accessName: '提示类型',
                        accessValueType: 'INT',
                        accessValue: 1.0,
                    },
                ],
            },
            {
                resourceLabel: 'TASK_EMAIL',
                resourceName: '任务邮件',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'SCHEDULE_EMAIL',
                resourceName: '日程邮件',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'MULTI_SEND_SINGLE_SHOW',
                resourceName: '群发单显',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
            {
                resourceLabel: 'WRITE_EMAIL_AUTO_CORRECT_ENTRANCE',
                resourceName: '写信页自动纠错入口',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: false,
                    },
                ],
            },
        ],
    },
};
class GlobalAuthsStore {
    constructor() {
        this.latestGetTime = null;
        this.globalAuths = [];
    }
    reset() {
        this.latestGetTime = null;
        this.globalAuths = [];
    }
}
GlobalAuthsStore.defGlobalAuthsParams = {
    productId: 'sirius',
    productVersionId: 'trial',
};
GlobalAuthsStore.expireTime = 5 * 60 * 1000;
const parseConfig = {
    [AuthorityFeature.READ_EMIAIL](authConfig) {
        const { accessValue, accessLabel, accessValueType } = authConfig;
        let value = accessValue;
        if (accessValueType === 'JSON') {
            try {
                value = JSON.parse(accessValue);
            }
            catch (e) {
                console.error(e);
            }
        }
        return {
            name: (AuthorityFeature.READ_EMIAIL + '_' + accessLabel),
            show: true,
            desc: value,
        };
    },
};
const defautlAuthConfigParse = (key, authConfig) => {
    const { accessValue, accessLabel } = authConfig;
    return {
        name: (key + '_' + accessLabel),
        show: !!accessValue,
        desc: null,
    };
};
class ProductAuthApiImpl {
    constructor() {
        this.productAuthSynced = false;
        this.hasTriggerABSwitchRequest = false;
        this.tagInfos = ProductAuthApiImpl.defaultTagInfos;
        this.productInfo = ProductAuthApiImpl.defaultProductInfo;
        this.requestAuthConfigNetLock = false;
        this.abSwitch = {
            forbidden_writelog: false,
            contact_cache: false,
            longtask: false,
            localdb: false,
            cache_contact: false,
            show_new_web_entry_guide: false,
            address_transfer2_crm_done: false,
            edm_mail: inEdm,
            skip_full_enterprise: false,
            build_unitpath_local: false,
            disable_ui_binding_outlook: false,
            disable_ui_binding_gmail: false,
            disable_ui_binding_qiyeqq: false,
            edm_menu_video: '',
            mail_ai_forbidden_domains: '',
            sidebar_document_forbidden_domains: '',
            web_client_download_forbidden_domains: '',
            sidebar_schedule_forbidden_domains: '',
            default: '',
        };
        this.productConfig = {
            learning_video: null,
        };
        this.name = apis.productAuthApiImpl;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
        this.storeApi = api.getDataStoreApi();
        this.globalAuthsStore = new GlobalAuthsStore();
        this.getAuthConfig = this.getAuthConfig.bind(this);
        this.saveAuthConfigFromNet = this.saveAuthConfigFromNet.bind(this);
    }
    getStoreAuthInfo() {
        var _a;
        return (_a = this.storeApi.getSync(AUTH_CONFIG)) === null || _a === void 0 ? void 0 : _a.data;
    }
    setStoreAuthInfo(authInfoStr) {
        return this.storeApi.putSync(AUTH_CONFIG, authInfoStr);
    }
    unpackRes(res) {
        console.log('[product auth] from network:', res);
        if (res && res.data && res.data.success) {
            return res.data.data;
        }
        if (res && res.data) {
            return Promise.reject({
                title: res.data.message,
                code: res.data.code,
            });
        }
        return Promise.reject({
            title: '请求失败',
            code: 'SERVER.ERR',
        });
    }
    async getABSwitch(field) {
        if (typeof field === 'undefined') {
            return this.abSwitch;
        }
        return this.abSwitch[field];
    }
    getABSwitchSync(field) {
        if (typeof field === 'undefined') {
            return this.abSwitch;
        }
        if (field === 'online_doc_allow_ids') {
            const idData = this.storeApi.getSync('online_doc_allow_ids', {
                storeMethod: 'localStorage',
                noneUserRelated: true,
            });
            const { data, suc } = idData;
            if (suc && data)
                return data;
            return '';
        }
        return this.abSwitch[field];
    }
    doGetGlobalAuths(req) {
        const url = this.systemApi.getUrl('getAllAuthorities');
        return this.http.get(url, req || GlobalAuthsStore.defGlobalAuthsParams).then(res => this.unpackRes(res));
    }
    async fetchProductTagInfo() {
        let res = null;
        try {
            res = await this.http.get(this.systemApi.getUrl('clientTagInfo'));
        }
        catch (e) {
            console.error('[productAuth] getProductTagFromNetwork got error', e);
        }
        console.log('[productAuth] get tag successful ', res);
        if (res && res.data && res.data.success && res.data.data) {
            const { tags } = res.data.data;
            this.tagInfos = tags;
            this.productAuthSynced = true;
        }
        return res;
    }
    doGetProductAuthTagsSync() {
        return this.tagInfos || [];
    }
    async doGetProductAuthTags() {
        if (!this.productAuthSynced) {
            await this.fetchProductTagInfo();
        }
        return this.tagInfos;
    }
    async doGetProductVersion() {
        var _a, _b, _c;
        if (!((_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.productId)) {
            try {
                const config = (_b = this.storeApi.getSync(AUTH_TYPE_CONFIG)) === null || _b === void 0 ? void 0 : _b.data;
                if (config) {
                    this.productInfo = JSON.parse(config);
                }
                else {
                    await this.saveAuthConfigFromNet();
                    const newConfig = (_c = this.storeApi.getSync(AUTH_TYPE_CONFIG)) === null || _c === void 0 ? void 0 : _c.data;
                    if (newConfig) {
                        this.productInfo = JSON.parse(newConfig);
                    }
                }
            }
            catch (e) {
                console.error('auth error', e);
            }
        }
        return this.productInfo;
    }
    doGetProductVersionId() {
        return this.productInfo.productVersionId || 'sirius';
    }
    doGetProductInfo() {
        return this.productInfo;
    }
    async asyncGetProductVersionId(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        const _account = params === null || params === void 0 ? void 0 : params._account;
        if (_account) {
            if ((_b = (_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.subAccountProductInfo) === null || _b === void 0 ? void 0 : _b.get(_account)) {
                return ((_e = (_d = (_c = this.productInfo) === null || _c === void 0 ? void 0 : _c.subAccountProductInfo) === null || _d === void 0 ? void 0 : _d.get(_account)) === null || _e === void 0 ? void 0 : _e.productVersionId) || 'sirius';
            }
            try {
                const res = await this.http.get(this.systemApi.getUrl('clientTagInfo'), undefined, { _account });
                console.log('[productAuth] get tag successful ', res);
                const { success, data: infoData } = (res === null || res === void 0 ? void 0 : res.data) || {};
                if (success && infoData) {
                    (_g = (_f = this.productInfo) === null || _f === void 0 ? void 0 : _f.subAccountProductInfo) === null || _g === void 0 ? void 0 : _g.set(_account, infoData);
                    return infoData.productVersionId || 'sirius';
                }
                return 'sirius';
            }
            catch (e) {
                console.error('[productAuth] getProductTagFromNetwork got error', e);
                return 'sirius';
            }
        }
        return this.productInfo.productVersionId || 'sirius';
    }
    init() {
        return this.name;
    }
    updateTrafficLabel(label) {
        if (!label)
            return;
        const [key, value] = label.split(':');
        if (!key || !value) {
            return;
        }
        this.http.addCommonHeader(key, value);
    }
    async fetchABSwitch() {
        var _a, _b;
        const productVersion = this.systemApi.inEdm() ? await this.doGetProductVersion() : null;
        const url = this.systemApi.getUrl('getABSwitch');
        try {
            const res = (await this.http.get(url, {
                matchPath: 'desktop_optimize',
                _productVersion: productVersion ? productVersion.productVersionId : undefined,
            }));
            if (!res.data) {
                res.data = {
                    data: {
                        desktop_optimize: {},
                    },
                };
            }
            let allAbSwitch = lodashGet(res, 'data.data.desktop_optimize', this.abSwitch);
            if (typeof (allAbSwitch === null || allAbSwitch === void 0 ? void 0 : allAbSwitch.online_doc_allow_ids) === 'string') {
                const ids = allAbSwitch.online_doc_allow_ids;
                this.storeApi.put('online_doc_allow_ids', ids, {
                    noneUserRelated: true,
                    storeMethod: 'localStorage',
                });
                allAbSwitch['online_doc_allow_ids'] && delete allAbSwitch['online_doc_allow_ids'];
            }
            this.abSwitch = allAbSwitch;
            if (((_a = this.abSwitch) === null || _a === void 0 ? void 0 : _a.default) && typeof ((_b = this.abSwitch) === null || _b === void 0 ? void 0 : _b.default) === 'string') {
                this.updateTrafficLabel(this.abSwitch.default);
                this.storeApi.put('sirius-it-gray#default', this.abSwitch.default, {
                    noneUserRelated: false,
                });
            }
        }
        catch (ex) {
            console.error('[abtest]error', ex);
        }
    }
    afterInit() {
        this.fetchABSwitch();
        this.fetchProductTagInfo()
            .then()
            .catch(err => console.warn(err));
        if (this.systemApi.getCurrentUser() && !this.hasTriggerABSwitchRequest) {
            this.fetchABSwitch();
            this.systemApi.intervalEvent({
                eventPeriod: 'long',
                handler: async (ev) => {
                    console.log('[abtest]', ev);
                    if (ev.seq % 10 === 0) {
                        this.fetchABSwitch();
                    }
                },
                seq: 0,
            });
            this.hasTriggerABSwitchRequest = false;
        }
        return this.name;
    }
    afterLogin() {
        this.globalAuthsStore.reset();
        this.fetchABSwitch();
        this.doGetGlobalAuths()
            .then(res => {
            this.globalAuthsStore.globalAuths = res.privileges;
            this.globalAuthsStore.latestGetTime = new Date().getTime();
        })
            .catch(error => {
            console.log('afterLogin doGetGlobalAuths error', error);
        });
        if (!this.hasTriggerABSwitchRequest) {
            this.fetchABSwitch();
            this.systemApi.intervalEvent({
                eventPeriod: 'long',
                handler: async (ev) => {
                    console.log('[abtest]', ev);
                    if (ev.seq % 10 === 0) {
                        this.fetchABSwitch();
                    }
                },
                seq: 0,
            });
            this.hasTriggerABSwitchRequest = false;
        }
        return this.name;
    }
    async saveAuthConfigFromNet(retry) {
        var _a, _b;
        retry = retry === undefined ? 2 : retry;
        try {
            const sync = this.storeApi.getSync(AUTH_CONFIG);
            if (sync && sync.suc && sync.data) {
                this.fetchProductTagInfo();
                if (!this.systemApi.getIsCorpMailMode()) {
                    this.doGetPrivilegeAll().then(res => {
                        var _a, _b;
                        if (res && res.data && ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.privileges)) {
                            this.mergeAndSaveAuthConfig((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.privileges);
                            const { productId, productVersionId, productVersionName, navigateVersion } = (res === null || res === void 0 ? void 0 : res.data) || {};
                            const productInfo = {
                                productId,
                                productVersionId,
                                productVersionName,
                                navigateVersion,
                            };
                            this.storeApi.putSync(AUTH_TYPE_CONFIG, JSON.stringify(productInfo));
                        }
                        console.log('[productAuth] get auth ', res);
                    });
                }
            }
            else {
                this.fetchProductTagInfo();
                if (!this.systemApi.getIsCorpMailMode()) {
                    const res = await this.doGetPrivilegeAll();
                    if (res && res.data && ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.privileges)) {
                        this.mergeAndSaveAuthConfig((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.privileges);
                        const { productId, productVersionId, productVersionName, navigateVersion } = (res === null || res === void 0 ? void 0 : res.data) || {};
                        const productInfo = {
                            productId,
                            productVersionId,
                            productVersionName,
                            navigateVersion,
                        };
                        this.storeApi.putSync(AUTH_TYPE_CONFIG, JSON.stringify(productInfo));
                    }
                    console.log('[productAuth] get auth ', res);
                }
            }
            return true;
        }
        catch (e) {
            console.error('[productAuth] get auth failed ', e);
            if (retry > 0) {
                await wait(1500 * (3 - retry) + 500);
                if (!this.systemApi.getIsCorpMailMode()) {
                    return this.saveAuthConfigFromNet(retry - 1);
                }
            }
            return Promise.reject(new Error('权限请求失败'));
        }
    }
    async getGlobalAuthsWithCache() {
        const nowTime = new Date().getTime();
        const { latestGetTime, globalAuths } = this.globalAuthsStore;
        if (latestGetTime && nowTime - latestGetTime < GlobalAuthsStore.expireTime) {
            return {
                success: true,
                source: 'cache',
                val: globalAuths,
                changed: false,
            };
        }
        try {
            const res = await this.doGetGlobalAuths();
            this.globalAuthsStore.globalAuths = res.privileges;
            this.globalAuthsStore.latestGetTime = nowTime;
            return {
                success: true,
                source: 'net',
                val: this.globalAuthsStore.globalAuths,
                changed: !!(JSON.stringify(this.globalAuthsStore.globalAuths) === JSON.stringify(globalAuths)),
            };
        }
        catch (error) {
            console.log('getGlobalAuthsWithCache error', error);
            return {
                success: false,
                source: 'cache',
                val: globalAuths,
                changed: false,
                error,
            };
        }
    }
    async getGlobalAuthsWithoutCache() {
        const { globalAuths } = this.globalAuthsStore;
        try {
            const res = await this.doGetGlobalAuths();
            this.globalAuthsStore.globalAuths = res.privileges;
            this.globalAuthsStore.latestGetTime = new Date().getTime();
            return {
                success: true,
                source: 'net',
                val: this.globalAuthsStore.globalAuths,
            };
        }
        catch (error) {
            console.log('getAllAuthsWithoutCache error', error);
            return {
                success: false,
                source: 'cache',
                val: globalAuths,
                error,
            };
        }
    }
    async createPubClue(req) {
        const url = this.systemApi.getUrl('createPubClue');
        const params = Object.assign({ productType: 'Sirius', clueSource: 'LX_DESKTOP' }, req);
        return this.http
            .post(url, params, { contentType: 'json' })
            .then(res => {
            console.log('createPubClue', res);
            return res.data;
        })
            .catch(() => Promise.reject(new Error('request failed')));
    }
    async isOverTimeByPubClue() {
        const sync = this.storeApi.getSync(ProductAuthApiImpl.storeName);
        if (sync && sync.suc && sync.data) {
            const data = JSON.parse(sync.data);
            const saveDate = moment(data.time).hour(23).minute(59).second(59);
            return moment().isAfter(saveDate);
        }
        return true;
    }
    async savePubClueTime() {
        this.storeApi.putSync(ProductAuthApiImpl.storeName, JSON.stringify({ time: moment().valueOf() }));
    }
    getAuthConfig(key) {
        var _a;
        let res = null;
        if (!this.systemApi.getIsCorpMailMode()) {
            if (this.LocalAuthorityConfig) {
                res = Object.freeze(this.LocalAuthorityConfig[key]) || null;
            }
            else {
                const strConfig = (_a = this.storeApi.getSync(AUTH_CONFIG)) === null || _a === void 0 ? void 0 : _a.data;
                if (strConfig) {
                    try {
                        this.LocalAuthorityConfig = Object.freeze(JSON.parse(strConfig));
                        res = (this.LocalAuthorityConfig && Object.freeze(this.LocalAuthorityConfig[key])) || null;
                    }
                    catch (e) {
                        console.warn(e);
                    }
                }
                else if (!this.requestAuthConfigNetLock && this.systemApi.getCurrentUser()) {
                    this.requestAuthConfigNetLock = !0;
                    this.saveAuthConfigFromNet();
                }
            }
        }
        return res;
    }
    mergeAndSaveAuthConfig(list) {
        const resConfig = {};
        try {
            list.forEach(config => {
                var _a;
                const key = config.resourceLabel;
                (_a = config === null || config === void 0 ? void 0 : config.accessList) === null || _a === void 0 ? void 0 : _a.forEach(element => {
                    const { accessLabel } = element;
                    const productAuthName = (key + '_' + accessLabel);
                    const parse = parseConfig[key];
                    if (parse) {
                        resConfig[productAuthName] = parse(element);
                    }
                    else {
                        resConfig[productAuthName] = defautlAuthConfigParse(key, element);
                    }
                });
            });
        }
        catch (e) {
            console.error(e);
        }
        this.LocalAuthorityConfig = resConfig;
        try {
            this.storeApi.putSync(AUTH_CONFIG, JSON.stringify(resConfig));
        }
        catch (e) {
            console.error(e);
        }
        return resConfig;
    }
    async doGetPrivilegeAll() {
        const requestPrivilegeFromCommonWeb = async (right_no) => {
            var _a, _b;
            const url = this.systemApi.getUrl('getAccountRight');
            try {
                const res = await this.http.get(url, { right_no }, { contentType: 'form' });
                return ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.data) || false;
            }
            catch (ex) {
                return true;
            }
        };
        const convertToPrivilegeResponse = (right, name) => {
            if (name === 'passchange') {
                return {
                    resourceLabel: 'ORG_SETTING_UPDATE_PASSWORD',
                    resourceName: '管理后台设置密码',
                    accessList: [
                        {
                            accessLabel: 'SHOW',
                            accessName: '显示',
                            accessValueType: 'BOOL',
                            accessValue: right,
                        },
                    ],
                };
            }
            return {
                resourceLabel: 'ORG_SETTING_BIG_ATTACH',
                resourceName: '管理后台云附件',
                accessList: [
                    {
                        accessLabel: 'SHOW',
                        accessName: '显示',
                        accessValueType: 'BOOL',
                        accessValue: right,
                    },
                ],
            };
        };
        return this.http
            .get(this.systemApi.getUrl('getPrivilegeAll'))
            .then(async (_res) => {
            var _a, _b;
            let res = _res;
            if (res.data == null || lodashGet(res, 'data.code', 999) !== 0) {
                console.error('getPrivilegeAll error fallback');
                res = { data: privilegeFallbackData };
            }
            const productId = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.productId;
            if (productId != null) {
                this.storeApi.putSync(PRODUCT_ID, productId);
            }
            await Promise.all(['passchange', 'bigattach'].map(async (right) => {
                var _a, _b;
                const flag = await requestPrivilegeFromCommonWeb(right);
                (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.privileges.push(convertToPrivilegeResponse(flag, right));
            }));
            return res.data;
        })
            .catch(e => {
            console.error('getPrivilegeAll error fallback, catch: ', e);
            return { data: privilegeFallbackData };
        });
    }
    async doGetProductTags() {
        return this.http.get(this.systemApi.getUrl('getProductTags')).then(res => {
            console.log(res);
            if (res.data) {
                return res.data.data;
            }
            throw new Error('获取版本信息失败');
        });
    }
    async doGetPrivilege() {
        return this.http.get(this.systemApi.getUrl('getPrivilege')).then(res => {
            if (res.data == null || lodashGet(res, 'data.code', 999) !== 0) {
                throw new Error(lodashGet(res, 'data.message', '获取账号版本功能权限失败'));
            }
            return res.data;
        });
    }
    async doGetProductVideos(videoId) {
        var _a;
        if (this.productConfig.learning_video && this.productConfig.learning_video[videoId]) {
            return this.productConfig.learning_video[videoId];
        }
        const url = this.systemApi.getUrl('getProductVideos');
        const res = (await this.http.get(url, { videoId }));
        if (!((_a = res.data) === null || _a === void 0 ? void 0 : _a.data)) {
            return null;
        }
        const result = res.data.data[videoId] || null;
        if (result) {
            if (!this.productConfig.learning_video) {
                this.productConfig.learning_video = {};
            }
            this.productConfig.learning_video[videoId] = result;
        }
        return result;
    }
}
ProductAuthApiImpl.storeName = 'pubClueInfo';
ProductAuthApiImpl.defaultTagInfos = [];
ProductAuthApiImpl.defaultProductInfo = {
    productId: '',
    productVersionId: 'others',
    productVersionName: '',
    showVersionTag: false,
    subAccountProductInfo: new Map(),
};
ProductAuthApiImpl.SWITCH_MAX_STORE_DURATION = 2 * 60 * 60 * 1000;
const productAuthApiImpl = new ProductAuthApiImpl();
api.registerLogicalApi(productAuthApiImpl);
export default productAuthApiImpl;
